import { useRef, useState } from "react";
import { Trans, t } from "@lingui/macro";
import { BiEditAlt } from "react-icons/bi";
import Card from "../Common/Card";
import Modal from "../Modal/Modal";
import Tooltip from "../Tooltip/Tooltip";
import { shortenAddress } from "lib/legacy";
import EmptyMessage from "./EmptyMessage";
import InfoCard from "./InfoCard";
import { getTierIdDisplay, getUSDValue, tierDiscountInfo, floor } from "./referralsHelper";
import { ReferralCodeForm } from "./JoinReferralCode";
import { getExplorerUrl } from "config/chains";
import { formatAmount } from "lib/numbers";
import { getNativeToken, getToken } from "config/tokens";
import { formatDate } from "lib/dates";

function TradersStats ({ referralsData,referralInfoData,userTradeReward, traderTier, chainId, userReferralCodeString, setPendingTxns, pendingTxns ,setUserReferralCodes}) {

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const editModalRef = useRef(null);

  const open = () => setIsEditModalOpen(true);
  const close = () => setIsEditModalOpen(false);

  return (
    <div className="rebate-container">

      <div className="referral-code">
        <div>
          <div className="active-code"><Trans>Active Referral Code</Trans></div>
          <div className="edit">
            <span>{userReferralCodeString}</span>
             <BiEditAlt onClick={open} /> 
          </div>
          {traderTier && (
            <div className="tier">
              <Tooltip
                handle={t`Tier ${referralInfoData.level} (${referralInfoData.levelRate}% discount)`}
                position="right-bottom"
                renderContent={() => (
                  <p className="text-white">
                    <Trans>
                      You will receive a {referralInfoData.levelRate}% discount on your opening and closing fees,
                      this discount will be airdropped to your account every Wednesday
                    </Trans>
                  </p>
                )}
              />
            </div>
          )}
          <div className="referral-stats">
            {/* <InfoCard
          label={t`total Trading Volume`}
          tooltipText={t`Volume traded by this account with an active referral code.`}
          // tooltipText={t`The total trading volume of this account under all referral codes.`}
          // tooltipText={<Trans>The trading volume of this account under the {userReferralCodeString} referral code.</Trans>}
          data={getUSDValue(referralsData?.referralTotalStats?.userVolume)}
        />
        <InfoCard
          label={t`Total Rebates`}
          tooltipText={t`Rebates earned by this account as a trader.`}
          data={getUSDValue(referralsData?.referralTotalStats?.totalDiscountUsd, 4)}
        />

        <InfoCard
          label={t`Active Referral Code`}
          data={
            <div className="active-referral-code">
              <div className="edit">
                <span>{userReferralCodeString}</span>
                <BiEditAlt onClick={open} />
              </div>
              {traderTier && (
                <div className="tier">
                  <Tooltip
                    handle={t`Tier ${getTierIdDisplay(traderTier)} (${tierDiscountInfo[traderTier]}% discount)`}
                    position="right-bottom"
                    renderContent={() => (
                      <p className="text-white">
                        <Trans>
                          You will receive a {tierDiscountInfo[traderTier]}% discount on your opening and closing fees,
                          this discount will be airdropped to your account every Wednesday
                        </Trans>
                      </p>
                    )}
                  />
                </div>
              )}
            </div>
          }
        /> */}
            <Modal
              className="Connect-wallet-modal"
              isVisible={isEditModalOpen}
              setIsVisible={close}
              label={t`Edit Referral Code`}
              onAfterOpen={() => editModalRef.current?.focus()}
            >
              <div className="edit-referral-modal">
                <ReferralCodeForm
                  userReferralCodeString={userReferralCodeString}
                  setPendingTxns={setPendingTxns}
                  pendingTxns={pendingTxns}
                  type="edit"
                  callAfterSuccess={() => setIsEditModalOpen(false)}
                  setUserReferralCodes={setUserReferralCodes}
                />
              </div>
            </Modal>
          </div>
        </div>
      </div>
      <div className="referral-detailed-data">
        <div className="information-card">
          <div className="information-card-title">
            <Trans>Total Team Data</Trans>
          </div>
          <div className="information-card-divider"></div>
          <div className="information-card-content">
            <div className="information-card-row">
              <div className="label">
                <Trans>Cumulative trading volume</Trans>
              </div>
              <div className="value">${floor(referralInfoData.tradeSum)}</div>
            </div>
            <div className="information-card-row">
              <div className="label">
                <Trans>Trading volume this week</Trans>
              </div>
              <div className="value">${floor(referralInfoData.tradeUsd)}</div>
            </div>
          </div>
        </div>

        <div className="information-card">
          <div className="information-card-title">
            <Trans>Individual Data</Trans>
          </div>
          <div className="information-card-divider"></div>
          <div className="information-card-content">
            <div className="information-card-row">
              <div className="label">
                <Trans>Cumulative trading volume</Trans>
              </div>
              <div className="value">${floor(userTradeReward.usertraderSum)}</div>
            </div>
            <div className="information-card-row">
              <div className="label">
                <Trans>Trading volume this week</Trans>
              </div>
              <div className="value">${floor(userTradeReward.usertraderUsd)}</div>
            </div>
          </div>
        </div>
        <div className="information-card">
          <div className="information-card-title">
            <Trans>Total Discount value</Trans>
          </div>
          <div className="information-card-divider"></div>
          <div className="information-card-content">
            <div className="information-card-row">
              <div className="data">${floor(userTradeReward.traderSum)}</div>
            </div>
          </div>
        </div>
        {/* <div className="information-card">
          <div className="information-card-title">团队数据</div>
          <div className="information-card-divider"></div>
          <div className="information-card-content">
            <div className="information-card-row">
              <div className="value">{userReferralCodeString}</div>
              {traderTier && (
                <div className="tier">
                  <Tooltip
                    handle={t`Tier ${getTierIdDisplay(traderTier)} (${tierDiscountInfo[traderTier]}% discount)`}
                    position="right-bottom"
                    renderContent={() => (
                      <p className="text-white">
                        <Trans>
                          You will receive a {tierDiscountInfo[traderTier]}% discount on your opening and closing fees,
                          this discount will be airdropped to your account every Wednesday
                        </Trans>
                      </p>
                    )}
                  />
                </div>
              )}
            </div>
          </div>
        </div> */}
      </div>
      {referralsData?.discountDistributions.length > 0 ? (
        <div className="reward-history">
          <Card title="Rebates Distribution History" tooltipText="Rebates are airdropped weekly.">
            <div className="table-wrapper">
              <table className="referral-table">
                <thead>
                  <tr>
                    <th className="table-head" scope="col">
                      <Trans>Date</Trans>
                    </th>
                    <th className="table-head" scope="col">
                      <Trans>Amount</Trans>
                    </th>
                    <th className="table-head" scope="col">
                      <Trans>Transaction</Trans>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {referralsData?.discountDistributions.map((rebate, index) => {
                    let tokenInfo;
                    try {
                      tokenInfo = getToken(chainId, rebate.token);
                    } catch {
                      tokenInfo = getNativeToken(chainId);
                    }
                    const explorerURL = getExplorerUrl(chainId);
                    return (
                      <tr key={index}>
                        <td data-label="Date">{formatDate(rebate.timestamp)}</td>
                        <td data-label="Amount">
                          {formatAmount(rebate.amount, tokenInfo.decimals, 6, true)} {"AVT"}
                        </td>
                        <td data-label="Transaction">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={explorerURL + `tx/${rebate.transactionHash}`}
                          >
                            {shortenAddress(rebate.transactionHash, 20)}
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      ) : (
        <EmptyMessage
          message={t`No rebates distribution history yet.`}
          tooltipText={t`Rebates are airdropped weekly.`}
        />
      )}
    </div>
  );
}

export default TradersStats;
